import {
    PHOTO_VALIDATION_ERROR_FILE_SIZE,
    PHOTO_VALIDATION_ERROR_IMAGE_DIMENSIONS,
    PHOTO_VALIDATION_ERROR_IMAGE_LOAD_ERROR,
    PHOTO_VALIDATION_ERROR_IMAGE_SQUARE_DIMENSIONS,
    PHOTO_VALIDATION_ERROR_MIME_TYPE
} from '../constants/photo.constants';

export class ValidationError {
    constructor(public key: string) {}

    public getMessage() {
        switch (this.key) {
            case PHOTO_VALIDATION_ERROR_MIME_TYPE:
                return 'Photos must be .jpg, .heic, .heif, .bmp, .png, or .gif';
            case PHOTO_VALIDATION_ERROR_FILE_SIZE:
                return 'Photos must be smaller than 5MB';
            case PHOTO_VALIDATION_ERROR_IMAGE_DIMENSIONS:
                return 'Photos must be at least 500 pixels tall or wide';
            case PHOTO_VALIDATION_ERROR_IMAGE_LOAD_ERROR:
                return 'There is a problem with this photo';
            case PHOTO_VALIDATION_ERROR_IMAGE_SQUARE_DIMENSIONS:
                return 'Photo must be square in size';
        }
        return '';
    }
}
